import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Sales.ContractRefundDocument.Delete.IRequest;
type Response = Api.Sales.ContractRefundDocument.Delete.IResponse;
type Headers = Api.Sales.ContractRefundDocument.Delete.IHeaders;
const url = '/api/Sales/ContractRefund/:id/Documents/:documentId';
export default async function contractRefundDocumentDeleteApi(params: {
  id: number;
  documentId: number;
}): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
